import "@/assets/style/global.css";
import Vue from "vue";
import App from "./App.vue";
import {Tracker} from './utils/tracker';
import {createMarketingBridge} from "@/utils/marketing";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import '@mdi/font/css/materialdesignicons.css'
import ConsentPlugin from "@/plugins/consent";

Vue.use(Vuetify);
Vue.use(ConsentPlugin, {
    required: process.env.VUE_APP_COOKIE_CONSENT_REQUIRED !== 'false',
    cookieNames: process.env.VUE_APP_COOKIE_CONSENT_COOKIE_NAMES,
    analyticsCookieNames: process.env.VUE_APP_COOKIE_CONSENT_ANALYTICS_COOKIE_NAMES,
    marketingCookieNames: process.env.VUE_APP_COOKIE_CONSENT_MARKETING_COOKIE_NAMES,
    preferencesCookieNames: process.env.VUE_APP_COOKIE_CONSENT_PREFERENCES_COOKIE_NAMES,
    analyticsAliases: process.env.VUE_APP_COOKIE_CONSENT_ANALYTICS_ALIASES,
    marketingAliases: process.env.VUE_APP_COOKIE_CONSENT_MARKETING_ALIASES,
    preferencesAliases: process.env.VUE_APP_COOKIE_CONSENT_PREFERENCES_ALIASES,
    analyticsGroupIds: process.env.VUE_APP_COOKIE_CONSENT_ANALYTICS_GROUP_IDS,
    marketingGroupIds: process.env.VUE_APP_COOKIE_CONSENT_MARKETING_GROUP_IDS,
    preferencesGroupIds: process.env.VUE_APP_COOKIE_CONSENT_PREFERENCES_GROUP_IDS,
    grantedValues: process.env.VUE_APP_COOKIE_CONSENT_GRANTED_VALUES,
    deniedValues: process.env.VUE_APP_COOKIE_CONSENT_DENIED_VALUES,
});

Vue.config.productionTip = false;
Vue.config.baseUrl = ''

let tracker = null
const getTracker = () => {
    if (tracker || !Vue.prototype.$consent?.canUse('analytics')) return tracker

    tracker = new Tracker({
        project: 'NewCarLoan-V2',
        debug: process.env.NODE_ENV === 'development',
    });

    return tracker
}

Vue.prototype.$tracker = {
    track(...args) {
        getTracker()?.track(...args)
    },
    trackError(...args) {
        getTracker()?.trackError(...args)
    },
    manualFlush() {
        return tracker?.manualFlush()
    },
    stop() {
        return tracker?.stop()
    },
}
let adjustSdk = null
let adjustPromise = null

const loadGtm = () => {
    const gtmId = process.env.VUE_APP_GTM_ID
    if (!gtmId || document.getElementById('gtm-script')) return

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'})

    const script = document.createElement('script')
    script.id = 'gtm-script'
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`
    document.head.appendChild(script)
}

const loadAdjust = () => {
    const adjustEnv = process.env.VUE_APP_ADJUST_ENV
    if (!adjustEnv) return Promise.resolve(null)
    if (adjustSdk) return Promise.resolve(adjustSdk)
    if (adjustPromise) return adjustPromise

    adjustPromise = import('@adjustcom/adjust-web-sdk')
        .then(module => {
            const Adjust = module.default || module

            Adjust.initSdk({appToken: "lps82prtb4e8", environment: adjustEnv});
            window.Adjust = Adjust
            adjustSdk = Adjust

            return Adjust
        })
        .catch(error => {
            adjustPromise = null
            throw error
        })

    return adjustPromise
}

Vue.prototype.$marketing = createMarketingBridge(Vue.prototype.$consent, loadAdjust);

const syncThirdParty = () => {
    if (Vue.prototype.$consent?.canUse('analytics')) {
        loadGtm()
        getTracker()
    }

    if (Vue.prototype.$consent?.canUse('marketing')) {
        loadAdjust()
    }
}

syncThirdParty()
Vue.prototype.$consent?.onChange(syncThirdParty)

new Vue({
    vuetify: new Vuetify({
        icons: {
            iconfont: 'mdi',
        },
        theme: {
            themes: {
                light: {
                    primary: '#0AAC5F',
                },
            },
        }
    }),
    render: (h) => h(App),
}).$mount("#app");
